export default function(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000;
    if (typeof requestIdleCallback === "function") {
        requestIdleCallback(callback, {
            timeout: timeout
        });
    } else {
        setTimeout(callback, 0);
    }
}

 //# sourceMappingURL=requestIdleCallback.js.map